import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export var useNotificationsStore = defineStore({
  id: 'notifications',
  state: function state() {
    return {
      notifications: [],
      unreadCount: 0,
      length: 0,
      loading: true,
      hydrated: false
    };
  },
  actions: {
    setUnread: function setUnread(val) {
      this.unreadCount = val;
      if (val) this.setBadge(val);else this.clearBadge();
    },
    add: function add(notification) {
      if (!this.hydrated) return;
      if (!this.notifications.some(function (o) {
        return o.id == notification.id;
      })) {
        notification.read = !!notification.read;
        this.notifications.unshift(notification);
      }
    },
    hydrate: function hydrate() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, notifications;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this.$nuxt.$auth.user) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", _this.hydrated = true);
            case 2:
              _context.next = 4;
              return _this.$nuxt.$axios.$get('/notification/find', {
                progress: false,
                params: {
                  limit: 20
                }
              }).catch(function (err) {
                return console.log(err);
              });
            case 4:
              data = _context.sent;
              if (data) {
                notifications = data.notifications.map(function (o) {
                  o.read = !!o.read;
                  return o;
                });
                _this.notifications = notifications;
                _this.length = data.length;
                _this.hydrated = true;
                _this.loading = false;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    load: function load() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data, _this2$notifications, notifications;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this2.loading) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _this2.loading = true;
              _context2.next = 5;
              return _this2.$nuxt.$axios.$get('/notification/find', {
                progress: false,
                params: {
                  limit: 20,
                  skip: _this2.notifications.length
                }
              }).catch(function (err) {
                return console.log(err);
              });
            case 5:
              data = _context2.sent;
              if (data) {
                notifications = data.notifications.map(function (o) {
                  o.read = !!o.read;
                  return o;
                });
                (_this2$notifications = _this2.notifications).push.apply(_this2$notifications, _toConsumableArray(notifications));
                _this2.length = data.length;
                _this2.loading = false;
              }
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    read: function read(_ref) {
      var id = _ref.id,
        read = _ref.read;
      var index = this.notifications.findIndex(function (t) {
        return t.id === id;
      });
      if (index >= 0) this.notifications[index].read = read;
    },
    mark: function mark(_ref2) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var id, read, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              id = _ref2.id, read = _ref2.read;
              _this3.read({
                id: id,
                read: read
              });
              _context3.next = 4;
              return _this3.$nuxt.$axios.$get('/notification/mark', {
                progress: false,
                params: {
                  id: id
                }
              }).catch(function (err) {
                return console.log(err);
              });
            case 4:
              data = _context3.sent;
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    readAll: function readAll() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this4.markAllread();
              _context4.next = 3;
              return _this4.$nuxt.$axios.$get('/notification/readAll', {
                progress: false
              }).catch(function (err) {
                return console.log(err);
              });
            case 3:
              data = _context4.sent;
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    markAllread: function markAllread() {
      var _this5 = this;
      this.notifications.forEach(function (notification, index) {
        _this5.notifications[index].read = true;
      });
      this.setUnread(0);
    },
    checkUnread: function checkUnread() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this6.$nuxt.$axios.$get('/notification/checkUnread', {
                progress: false
              }).catch(function (err) {
                return console.log(err);
              });
            case 2:
              data = _context5.sent;
              if (data) _this6.setUnread(data.count);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    setBadge: function setBadge(count) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!(process.client && 'setAppBadge' in navigator)) {
                _context6.next = 9;
                break;
              }
              _context6.prev = 1;
              _context6.next = 4;
              return navigator.setAppBadge(count);
            case 4:
              _context6.next = 9;
              break;
            case 6:
              _context6.prev = 6;
              _context6.t0 = _context6["catch"](1);
              console.error('Failed to set app badge:', _context6.t0);
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[1, 6]]);
      }))();
    },
    clearBadge: function clearBadge() {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(process.client && 'clearAppBadge' in navigator)) {
                _context7.next = 9;
                break;
              }
              _context7.prev = 1;
              _context7.next = 4;
              return navigator.clearAppBadge();
            case 4:
              _context7.next = 9;
              break;
            case 6:
              _context7.prev = 6;
              _context7.t0 = _context7["catch"](1);
              console.error('Failed to clear app badge:', _context7.t0);
            case 9:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[1, 6]]);
      }))();
    }
  }
});